import { WrapRootElementNodeArgs } from "gatsby";
import React from "react";
import { Provider } from "react-redux";

import { store } from "./store";

export function attachStore({ element }: WrapRootElementNodeArgs) {
  return <Provider store={store}>{element}</Provider>;
}
